import { Component, computed, OnInit, signal, ViewChild } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { dropdown } from 'src/app/modal/DAO';
import { workInProgress } from 'src/app/modal/routing.models';
import { CommonService } from 'src/app/services/commonService';
import { AgentListService } from 'src/app/services/agentList.service';
import { CardModule } from 'primeng/card';
import { SelectModule } from 'primeng/select';
import { ServiceLayer } from 'src/app/services/serviceLayer';

@Component({
  selector: 'nfp-reassign-submission',
  standalone: true,
  imports: [CommonModule, FormsModule, CardModule, SelectModule],
  templateUrl: './reassign-submission.component.html',
  styleUrls: ['./reassign-submission.component.css']
})
export class ReassignSubmissionComponent implements OnInit {
  curWorkInProgress = signal<workInProgress>({} as workInProgress);
  @ViewChild('f') reAssignSubmissionForm: NgForm;

  private allAgent = signal<Array<dropdown>>([]);
  public selectedAgent = signal("");
  public displayResponseMessage = signal("");
  // Exclude the current assigned agent from the dropdown options
  public otherAgents = computed(()=>{
    return this.allAgent().filter(agent => agent.value !== this.curWorkInProgress().email)
  })

  constructor(public agentListService: AgentListService, private commonService: CommonService, public serviceLayer: ServiceLayer) {}

  ngOnInit(): void {
    this.agentListService.getAgentList().subscribe(agents => {
      this.allAgent.set(agents);
    });
  }
  
  public onCloseClicked(): void {
    this.agentListService.shallDiplayReassignDialog.set(false);
  }

  public submit(): void {
    if (this.reAssignSubmissionForm.invalid) {
      return;
    }
    const selectedAgentDetail = this.allAgent().find(agent => agent.value === this.selectedAgent()); 
    const payload = {
      payloadData: {
        toUserName: selectedAgentDetail?.label,
        toEmail: selectedAgentDetail?.value,
        referenceNumber: this.curWorkInProgress().referenceNumber
      }
    };

    this.commonService.put('workInProgress', 'changeSubmissionAgent', payload).subscribe(
      (response) => {
        this.displayResponseMessage.set('Reassignment has been completed successfully.');
        this.agentListService.submissionReassigned.set(true);
      },
      (error) => {
        this.displayResponseMessage.set('Failed to re-assign submission. Please try again.');
      }
    );
  }
}